// React import
import * as React from 'react'
// Standard layout imports
import Title from 'src/components/Title';
import Box from 'src/components/Box';
import Wrapper from 'src/components/Wrapper';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';

import cirkelKompetance from '../../../images/about/cirkelKompetance.png'
import uroLogo from '../../../images/Logos/URO_logo.png'
import { Link } from 'react-router-dom';



class AboutPage extends React.Component{
    constructor(props: any){
        super(props);
        // Dispatch action to get the About page by ID
    }
    
    public render() {
        // Render the returned HTML
        

        const enrollmentAndTerms = (<div>
            <div style={{width: "100%", textAlign:"end"}}>
                <img src={cirkelKompetance} height="110px"  /> <br/>
                </div>
                <div>
                    <h2>Ansøgning og vilkår</h2>
                
        <p>Kurserne henvender sig til <i>samtlige</i> valgte og ansatte i 3F medmindre andet er angivet under det enkelte kursus.</p>
        <p>Tilmelding (ansøgning) kan foretages direkte i Kursusportalen.</p>
        <p>
        Visse kurser kræver en særlig ansøgning til URO eller HR. Det vil fremgå af kursusbeskrivelsen.
        </p>
        <p>
        Ønskes yderligere oplysninger om et konkret kursus, rettes henvendelse til kursusudbyderen; se kursusbeskrivelsen.
        </p>
        <p>
        HUSK at aftale eventuel kursusdeltagelse med din leder. 
        </p>
        <p>
        Man er først optaget på et kursus, når kursusudbyder har fremsendt en <u>endelig</u> kursusbekræftelse.
        </p>
        <p>
        Der ydes <i>ikke</i> kursusgodtgørelse eller arbejdstab for valgte og ansatte.
        </p>
        <p>
        Hvor intet andet er anført, refunderes rejseomkostninger svarende til gældende regler om billigste offentlige transportmiddel. 
        </p>
        <p>
        Hvis det <i>ikke</i> er muligt at nå frem til kursusstart (medmindre afrejse hjemmefra er før kl. 6.00), kan en ekstra overnatning aftales.
        </p>
        <p>
        Kursusudbyder dækker ophold og forplejning.
        </p>
        <p>
        Du er altid velkommen til at kontakte <a href="mailto:uro@3f.dk">uro@3f.dk</a> med spørgsmål og ideer. 
        </p>
        <p>
                <img src={uroLogo} height="70px"  />                  
                </p>
        </div>
        </div>)
        const aboutPortal = (<div>
            <div style={{width: "100%", textAlign:"end"}}>
                <img src={cirkelKompetance} height="110px"  /> <br/>
                </div>
            <div>
                
                <h2>Kursusportalen afløser det elektroniske kursuskatalog og det årlige cirkulære over kurser og uddannelser fra URO</h2>
                <p>Kursusportalen giver dig et dynamisk overblik over efteruddannelse som valgt eller ansat i 3F.</p>
                <p>
                    Kursusportalen indeholder tilbud på tværs af organisationen, som retter sig mod din jobprofil samt særlige opgaver. Ideelle jobfunktions- og arbejdsområdebeskrivelser kan du finde på 3FI/URO. 
                </p>
                <div>
                    <b>Se mere her </b><div style={{padding:"56.25% 0 0 0",position:"relative"}}><iframe src={"https://player.vimeo.com/video/314256857?loop=1"} style={{position:"absolute","top":0, "left":0,width:"100%",height:"100%"}}  /></div><script src="https://player.vimeo.com/api/player.js" />
                
                <br/><br/>
                
                    <b>Du kan</b>
                    <ul>
                        <li>Søge kurser</li>
                        <li>Tilmelde dig kurser</li>
                        <li>Gemme som favoritter</li>
                        <li>Tippe en ven</li>
                        <li>Se kurser du er optaget på</li>
                        <li>Finde din FIU kursushistorik</li>
                    </ul>
                    </div>
                <p>
                Du kan læse om tilbud om kompetenceafklaring i afdelingen og finde et link til 3F's e-læringsportal.  
                </p>
                <p>
                Kurserne administreres i FIU-systemet og finansieres af forbundets midler.
                </p>
                <p>
                Har du spørgsmål eller andet er du altid velkommen til at kontakte os i <a href="mailto:uro@3f.dk">uro@3f.dk</a>.
                </p>
                <p>
                <img src={uroLogo} height="70px"  />
                <br/>
                    <b>
                    Politisk ansvarlig: Tina Christensen, Næstformand
                    </b>
                    
                </p>
            </div>
            </div>)


        const skillAssestment = (<div>
            <div style={{width: "100%", textAlign:"end"}}>
                <img src={cirkelKompetance} height="110px"  /> <br/>
                </div>
                <div>
               <div style={{display:"inline-flex"}}> 
                   <h2>Kompetenceafklaring for valgte og ansatte.</h2>
               </div>
                <p>
                I 3Fs kompetencestrategi indgår en kompetenceafklaring, der identificerer de væsentligste udviklingsområder for både ledelse og medarbejdere i forhold til at klarlægge kompetencer, behov og interesser.
                </p>

                <p>
                Kompetenceafklaringen har til formål at afklare, anerkende og dokumentere den enkeltes faglige og personlige kompetencer samt behovet for opkvalificering.
                </p>
                <p>
                Ud over de faglige og personlige kompetencer afdækkes teamkvalifikationer, skyggekvalifikationer (kvalifikationer som man evt. har erhvervet, men som ikke bruges i nuværende jobfunktion, men som man måske er interesseret i at få i anvendelse igen).
                </p>
                <p>
                Hvis afdelingen er interesseret i at få tilrettelagt en kompetenceafklaring for samtlige valgte og ansatte, skal der søges herom via en handlingsplan. Hør mere hos regionskontoret eller URO. 
                </p>
                <p>
                Kompetenceafklaringen forestås af AOF i samarbejde med URO. Læs mere <a target="_blank" href="http://www.3fi.dk/3Fi.dk/Sekretariater/URO/Kompetencestrategien/Kompetenceafklaring/Folder%20om%20kompetenceafklaring.aspx">her</a>
                </p>
                <p>
                <img src={uroLogo} height="70px"  />
                <br/>
                    <b>
                    Politisk ansvarlig: Tina Christensen, Næstformand
                    </b>
                    
                </p>
                </div>
        </div>)
        let title = '';
        let htmlToRender = <div>loading</div>;
        switch(location.hash){
            case "#/About/about-course-portal" :
            htmlToRender = aboutPortal
            title = 'Om Portalen'
            break;
            case "#/About/enrollment-terms" :
            htmlToRender = enrollmentAndTerms
            title = 'Ansøgning og vilkår'
            break;
            case "#/About/about-skill-assessment" :
            htmlToRender = skillAssestment
            title = 'Om kompetenceafklaring'
            break;
        }
        return (<div className="has-background-gray-body pb4" >
        
            <Wrapper className="pt2">
            <Breadcrumb className="mb2" >
        {/* Map the items of the route here  */}
          <BreadcrumbItem><Link to="/">FORSIDE</Link></BreadcrumbItem>
          
          <BreadcrumbItem active={true}><Link to="">{title}</Link></BreadcrumbItem >
          
        </Breadcrumb>
            <div>
            <Title className="mb2">{title}</Title>
            </div>
            <Box className="mb4">
            {htmlToRender}
            </Box>
        </Wrapper></div>)
    }
}

export default AboutPage


// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/About/index.tsx